module.exports = __webpack_public_path__ + "media/images/faces/male/17-4c82607c78d881e798919a8ed31af6ee.jpg";